export default __webpack_public_path__ + "static/media/IndianRupeeFont-3w4Z.c389b139.ttf";